import React, {useState} from "react";
import ABDMApi from "../ABDMApi";
export default function DownloadABHACard({afterSuccess}) {
    const [loading, setLoading] = useState(false);
    const [image, setImage] = useState(null);
    const [error, setError] = useState("");
    const download = async () => {
        setLoading(true);
        setError("");
        try {
            const response = await ABDMApi({
                url: "abdm/abha-card/", method: "GET", responseType: "blob"
            });
            const url = URL.createObjectURL(response.data);
            setImage(url);
            // DON'T GO TO COMPLETE HERE
        } catch (e) {
            setError("Unable to download ABHA Card.");
        } finally {
            setLoading(false);
        }
    };
    return (<div className="card shadow-sm">

        <div className="card-header bg-success text-white">
            Download ABHA Card
        </div>

        <div className="card-body">

            {!image && (<button
                className="btn btn-primary"
                disabled={loading}
                onClick={download}
            >
                {loading ? "Downloading..." : "Download Card"}
            </button>)}

            {error && (<div className="alert alert-danger mt-3">
                {error}
            </div>)}

            {image && (<div className="text-center">

                <img
                    src={image}
                    alt="ABHA Card"
                    className="img-fluid border rounded"
                />

                <div className="mt-3">

                    <a
                        href={image}
                        download="ABHA_Card.png"
                        className="btn btn-success me-2"
                    >
                        Download PNG
                    </a>

                    <button
                        className="btn btn-primary"
                        onClick={() => afterSuccess && afterSuccess()}
                    >
                        Finish
                    </button>

                </div>

            </div>)}

        </div>

    </div>);
}